import {
  OS_SUPPORT_LIST_SET,
  OS_SUPPORT_LIST_REQ,
  OS_SUPPORT_LIST_SUCCESS,
  OS_SUPPORT_LIST_ERROR,
  OS_DOWNLOAD_PROGRESS_SET,
  OS_INSTALLATION_REQ,
  OS_INSTALLATION_SUCCESS,
  OS_INSTALLATION_ERROR
} from './os-support.type'

import ApiRest from '@/api/api-rest'

const state = {
  osSupportListReqStatus: '',
  osInstallationReqStatus: '',
  osSupportList: {},
  osDownloadProgress: {
    percentage: 0,
    status: ''
  }
}

const getters = {
  osSupportListReqStatus: state => state.osSupportListReqStatus,
  osInstallationReqStatus: state => state.osInstallationReqStatus,
  osSupportList: state => state.osSupportList,
  osDownloadProgress: state => state.osDownloadProgress
}

// Best Practice - updates state
const mutations = {
  [OS_SUPPORT_LIST_SET]: (state, data) => {
    state.osSupportList = data
  },
  [OS_SUPPORT_LIST_REQ]: state => {
    state.osSupportListReqStatus = 'loading'
  },
  [OS_SUPPORT_LIST_SUCCESS]: (state, data) => {
    state.osSupportListReqStatus = 'saved'
  },
  [OS_SUPPORT_LIST_ERROR]: (state, errMsg) => {
    state.osSupportListReqStatus = 'error'
  },
  [OS_DOWNLOAD_PROGRESS_SET]: (state, data) => {
    state.osDownloadProgress.percentage = data.percentage
    state.osDownloadProgress.status = data.status
  },
  [OS_INSTALLATION_REQ]: state => {
    state.osInstallationReqStatus = 'loading'
  },
  [OS_INSTALLATION_SUCCESS]: (state, data) => {
    state.osInstallationReqStatus = 'saved'
  },
  [OS_INSTALLATION_ERROR]: (state, errMsg) => {
    state.osInstallationReqStatus = 'error'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [OS_SUPPORT_LIST_REQ] (context) {
    return new Promise((resolve, reject) => {
      context.commit(OS_SUPPORT_LIST_REQ)
      ApiRest()
        .get('/os-support')
        .then(({ data }) => {
          data = _.groupBy(data, 'os_type')
          context.commit(OS_SUPPORT_LIST_SET, data)
          context.commit(OS_SUPPORT_LIST_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(OS_SUPPORT_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [OS_SUPPORT_LIST_SUCCESS] (context) {
    context.commit(OS_SUPPORT_LIST_SUCCESS)
  },
  [OS_DOWNLOAD_PROGRESS_SET] (context, { percentage, status }) {
    context.commit(OS_DOWNLOAD_PROGRESS_SET, {
      percentage: percentage,
      status: status
    })
  },
  [OS_INSTALLATION_REQ] (context, { osName, osType, osFilename }) {
    let percentCompleted = 0
    context.commit(OS_DOWNLOAD_PROGRESS_SET, {
      percentage: 0,
      status: 'start'
    })
    return new Promise((resolve, reject) => {
      context.commit(OS_INSTALLATION_REQ)
      ApiRest()
        .getFileDownload(`/installation/${osName}/${osType}`, progressEvent => {
          percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )
          context.commit(OS_DOWNLOAD_PROGRESS_SET, {
            percentage: percentCompleted,
            status: 'loading'
          })
        })
        .then(agentPkg => {
          let blob = new Blob([agentPkg.data], {
            type: agentPkg['Content-Type']
          })
          let link = document.createElement('a')
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob)
            link.setAttribute('href', url)
            link.setAttribute('download', osFilename)
            link.style.visibility = 'hidden'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
          context.commit(OS_INSTALLATION_SUCCESS)
          context.commit(OS_DOWNLOAD_PROGRESS_SET, {
            percentage: percentCompleted,
            status: 'success'
          })
          resolve({})
        })
        .catch(errMsg => {
          context.commit(OS_INSTALLATION_ERROR, errMsg)
          context.commit(OS_DOWNLOAD_PROGRESS_SET, {
            percentage: percentCompleted,
            status: 'error'
          })
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/os_support/os-support.module.js